// ----------------------------------------------------------------------
// <copyright file="Izenda.Button.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Button Component
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  const { noop } = require('lodash/fp');
  var Button = React.createClass({
    /**
     * initial properties
     * @returns {Object}
     */
    getDefaultProps: function() {
      return {
        className: '',
        label: '',
        onClick: noop,
        disabled: false
      };
    },

    componentDidMount: function() {
      // Initialize dropdown if parent (caller) component wants to render as dropdown
      if (this.props['data-toggle'] && this.props['data-toggle'] === 'dropdown') {
        $izenda(this.refs.btn).dropdown();
      }
    },

    /**
     * render component
     * @returns {Object}
     */
    render: function() {
      var classes = classnames('btn btn-primary', this.props.className);
      var whitespace = this.props.label && React.Children.count(this.props.children) > 0 ? ' ' : '';
      var label = this.props.label + whitespace;

      return (
        <button
          ref="btn"
          className={classes}
          onClick={this.props.onClick}
          disabled={this.props.disabled}
          title={this.props.title}
          data-toggle={this.props['data-toggle']}
        >
          {label}
          {this.props.children}
        </button>
      );
    }
  });

  module.exports = Button;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Button.jsx